module.exports = __webpack_public_path__ + "media/images/Warm-Abstract-1-57c3a084fa4b1a5d667090cd7b641ed1.png";